import { z } from 'zod';
import { UnitPresetPayloadSchema } from './preset-schemas';
import { LeadPayloadSchema, SellerSchema } from './lead-schemas';
import { ProjectionComponentsSchema } from './energy-schemas';

const CleanedUnitPresetPayloadSchema = UnitPresetPayloadSchema.transform((data) => {
  if (data.presetType === 'COMPETITOR_ACL' && data.presetPayload) {
    const { marginFee, rawEnergyPrice, ...cleanedPayload } = data.presetPayload as any;
    return {
      ...data,
      presetPayload: cleanedPayload,
    };
  }
  return data;
});

export const UnitPresetScenarioPayloadSchema = z.array(CleanedUnitPresetPayloadSchema);

export const ScenarioPayloadSchema = z.object({
  id: z.string().nullish(),
  scenarioIndex: z.number().nullish(),
  scenarioName: z.string().nullish(),
  scenarioPayload: UnitPresetScenarioPayloadSchema.nullish(),
});

export const SimulationPayloadSchema = z.object({
  leadInfo: LeadPayloadSchema.nullish(),
  seller: SellerSchema.nullish(),
  description: z.string().nullish(),
  validity: z.string().nullish(),
  isAlreadyAtAcl: z.boolean().default(false).nullish(),
  baseScenario: ScenarioPayloadSchema.nullish(),
  targetScenarios: z.array(ScenarioPayloadSchema).nullish(),
  aux__useGlobalSupplyStartDate: z.union([z.string().nullish(), z.date().nullish()]).nullish(),
  aux__useGlobalSupplyFinalDate: z.union([z.string().nullish(), z.date().nullish()]).nullish(),
  aux__useDifferentPeriodsByUnit: z.boolean().default(false).nullish(),
});

export const OptimizedScenarioPayloadSchema = z.object({
  id: z.string().nullish(),
  description: z.string().nullish(),
  unitPresetProjectionsIds: z.array(z.string()).nullish(),
});

export const SimulationInputsSchema = z.object({
  simulationId: z.string().nullish(),
  rawInputs: z.record(z.string(), z.unknown()).nullish(),
  parsedPayload: SimulationPayloadSchema.nullish(),
  parsedInputs: SimulationPayloadSchema.nullish(),
  projectionComponents: ProjectionComponentsSchema.nullish(),
  monthToSample: z.string().nullish(),
  optimizedScenario: OptimizedScenarioPayloadSchema.nullish(),
  unitPresetInputs: z.array(z.record(z.string(), z.unknown())).nullish(),
});

export const BaseScenarioSchema = ScenarioPayloadSchema;
